import React, { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DetailSkeleton from "../components/Skeleton/DetailSkeleton";
import { PostData } from "../services/FetchData";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { ProductContext } from "../store";
import { clearAuthSession } from "../services/authSession";
import { onAuthLoginSuccess } from "../services/clarityService";

const DEFAULT_RETURN_URL = "/aivisibility/audit-list";

const AiVisibilityAppLogin = ({ platform }) => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { setCurrentWebsiteId } = useContext(ProductContext);

	useEffect(() => {
		if (window.RvBotView) {
			window.RvBotView.destory();
		}
		clearAuthSession();
		Cookies.remove("_cb_search_token");
		Cookies.remove("_website_id");

		const uniqueId = searchParams.get("uniqueId");
		const apiKey = searchParams.get("apiKey");
		const returnUrl = searchParams.get("return_url") || DEFAULT_RETURN_URL;

		if (!uniqueId || !apiKey) {
			toast.error("Missing uniqueId or apiKey");
			navigate("/auth/login");
			return;
		}

		PostData(
			"ms1",
			"api/v1/user/aivisibilityAppLogin",
			{ uniqueId, apiKey, platform },
			false,
			false
		).then((response) => {
			if (response !== "Invalid") {
				if (response.status === "success") {
					Cookies.set("_cb_search_token", response.data.accessToken);
					onAuthLoginSuccess(response.data.user?.userId);
					Cookies.set("_website_id", response.data.websiteId);
					setCurrentWebsiteId(response.data.websiteId);
					navigate(returnUrl);
					return;
				}
				toast.error(response.message || "Login failed");
			}
			navigate("/auth/login");
		});
	}, [navigate, platform, searchParams, setCurrentWebsiteId]);

	return (
		<div>
			<DetailSkeleton />
		</div>
	);
};

export default AiVisibilityAppLogin;
